import PersonIcon from "@mui/icons-material/Person";
// MODIFIED: Updated path to common Input
import { Input } from "../../../../../common/Input";

export function ApproverSetupTab({
  isViewOnly,
  selectedEmployee,
  approverHierarchyCount,
  setApproverHierarchyCount,
  errorState
}) {
  return (
    <div className="space-y-4">
      <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
        <div className="py-2 border-b border-gray-300">
          <h3 className="font-medium text-gray-700 text-sm">Employee Information</h3>
        </div>
        <div className="pb-4 pt-3">
          {selectedEmployee ? (
            <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <PersonIcon className="text-blue-500" fontSize="small" />
                </div>
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-gray-700">
                    {selectedEmployee.employeeId} — {selectedEmployee.fullName}
                  </h3>
                  <div className="grid grid-cols-2 gap-2 text-xs mt-2">
                    <div><span className="text-gray-400">Dept:</span> {selectedEmployee.department || "N/A"}</div>
                    <div><span className="text-gray-400">Pos:</span> {selectedEmployee.position || "N/A"}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-sm text-gray-400 text-center">No Employee Selected</p>
          )}
        </div>
      </div>

      <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
        <div className="py-2 border-b border-gray-300">
          <h3 className="font-medium text-gray-700 text-sm">Hierarchy Configuration</h3>
        </div>
        <div className="pb-4 pt-3">
          <div className="w-full md:w-1/2">
            <Input
              label="Number of Hierarchy Levels"
              isRequired={true}
              isViewOnly={isViewOnly}
              type="number"
              min={1}
              max={10}
              value={approverHierarchyCount}
              onChange={(e) => setApproverHierarchyCount(parseInt(e.target.value) || 1)}
              error={!!errorState?.approverHierarchyCount}
              errorMessage="Enter 1–10 levels"
            />
          </div>
        </div>
      </div>
    </div>
  );
}